import { render, staticRenderFns } from "./couponCard.vue?vue&type=template&id=2817ceef&scoped=true&"
import script from "./couponCard.vue?vue&type=script&lang=js&"
export * from "./couponCard.vue?vue&type=script&lang=js&"
import style0 from "./couponCard.vue?vue&type=style&index=0&id=2817ceef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2817ceef",
  null
  
)

export default component.exports